import React from "react";

const SecurityContext = React.createContext({
    isAuthenticated: false,
    authenticate: () => {},
    deauthenticate: () => {},
});

export default SecurityContext;
